import React from "react";
import "../assests/CSS/FeaturesComponentThree.css";
import { featuresData } from "./data";

const FeaturesComponentThree = () => {
  return (
    <section className="features-container">
      <h2 className="features-title">{featuresData.title}</h2>
      <div className="features-grid">
        {featuresData.features.map((feature) => (
          <div key={feature.id} className="feature-card">
            <p>{feature.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesComponentThree;
